import React, { useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { ProviderImgMap } from "../../constants/common-utlits";
import { Provider } from "../../models/provider";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import { NavLink, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ArrowDownImg from "../../assets/images/angle.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { setProviderId, fetchBalance, setTheme } from "../../store";
import { useInterval } from "../../Hooks/useInterval";
import "./header.scss";

type HeaderProps = {
  providers: Provider[];
  setProviderId: Function;
  providerId: string;
  fetchBalance: Function;
  balance: number;
  currency: string;
  theme: string;
  setTheme: Function;
};

const HeaderPage: React.FC<HeaderProps> = (props) => {
  const {
    providers,
    setProviderId,
    providerId,
    fetchBalance,
    balance,
    currency,
    theme,
    setTheme,
  } = props;
  let navigate = useNavigate();
  // const [darkTheme, setDarkTheme] = useState<boolean>(false);
  const operatorId = sessionStorage.getItem("psOperatorId");
  const callBackUrl = sessionStorage.getItem("callBackUrl");

  const [state, setState] = React.useState({
    left: false,
  });

  useEffect(() => {
    fetchBalance();
    if (theme === "dark") {
      if (operatorId.toLowerCase() === "tigerexch") {
        document.documentElement.className = "theme-dark-tiger";
      } else {
        document.documentElement.className = "theme-dark";
      }
    } else {
      if (operatorId.toLowerCase() === "tigerexch") {
        document.documentElement.className = "theme-light-tiger";
      } else {
        document.documentElement.className = "theme-light";
      }
    }
  }, [theme]);

  useInterval(() => {
    fetchBalance();
  }, 1000 * 30);

  const changeProvider = (pid) => {
    navigate(`lobby/${pid}/inplay`);
    sessionStorage.setItem("psProviderId", pid);
    setProviderId(sessionStorage.getItem("psProviderId"));
  };

  const setThemeHandler = (e) => {
    if (e.target.checked) {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  };

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      setState({ ...state, left: open });
    };

  const redirectToMyBets = () => {
    navigate("/lobby/bet_list");
  };

  const onCloseIframe = () => {
    window.location.href = callBackUrl;
    return null;
  };

  return (
    <>
      {operatorId === "MPC1" ||
      operatorId === "karabet" ||
      operatorId === "luckystar" ? (
        <></>
      ) : (
        <AppBar className="main-header" color="transparent">
          <Toolbar variant="dense">
            {callBackUrl ? (
              <Button
                className="back-btn mob-view"
                onClick={() => onCloseIframe()}
              >
                <ArrowBackIcon />
                Back
              </Button>
            ) : null}

            {providers && providers.length > 0 ? (
              <div className="providers-ctn web-view">
                {providers?.map((provider: Provider) => (
                  <NavLink
                    key={provider.providerId}
                    to={`/lobby/${provider.providerId}/inplay`}
                    className="navlink"
                    onClick={() => changeProvider(provider?.providerId)}
                  >
                    <Button
                      onClick={() => changeProvider(provider?.providerId)}
                    >
                      <img
                        src={ProviderImgMap[provider?.providerId]}
                        alt={provider?.providerId}
                        className={
                          provider.providerId ===
                          sessionStorage.getItem("psProviderId")
                            ? "active-provider provider-img"
                            : "provider-img"
                        }
                      />
                    </Button>
                  </NavLink>
                ))}
              </div>
            ) : null}
            <div className="mob-view side-section">
              <React.Fragment>
                <Button>
                  {!state.left ? (
                    <MenuIcon className="menu" onClick={toggleDrawer(true)} />
                  ) : (
                    <CloseIcon className="menu" onClick={toggleDrawer(false)} />
                  )}
                </Button>
                <Drawer
                  open={state.left}
                  onClose={toggleDrawer(false)}
                  className="drawer"
                >
                  <Box
                    sx={{ width: 250 }}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                  >
                    <List>
                      {providers?.map((provider: Provider) => (
                        <React.Fragment key={provider.providerId}>
                          <NavLink
                            to={`/lobby/${provider.providerId}/inplay`}
                            className="nav-link provider"
                            onClick={() => changeProvider(provider.providerId)}
                          >
                            <ListItem
                              button
                              className="provider-list"
                            >
                              <ListItemText primary={provider.providerId} />
                            </ListItem>
                          </NavLink>

                          <Divider />
                        </React.Fragment>
                      ))}
                    </List>
                  </Box>
                </Drawer>
              </React.Fragment>
            </div>

            <div className="balance-ctn">
              <Button
                className="bal-btn"
                variant="contained"
                color="primary"
                size="small"
              >
                <div className="web-view">Balance</div>{" "}
                <div className="mob-view">
                  <AccountBalanceIcon />
                </div>
                :{balance ? balance : 0}
              </Button>

              <Button
                className="refrsh-btn web-view"
                variant="text"
                color="primary"
                size="small"
                onClick={() => {
                  fetchBalance();
                }}
              >
                <AutorenewIcon />
              </Button>

              <Button
                className="bets-btn"
                variant="text"
                color="primary"
                size="small"
                onClick={redirectToMyBets}
              >
                My Bets
              </Button>

              <label id="switch" className="switch">
                <input
                  type="checkbox"
                  name="darkTheme"
                  checked={theme == "dark"}
                  onChange={(e) => setThemeHandler(e)}
                  className="slider"
                />
                <span className="slider round"></span>
              </label>
            </div>
          </Toolbar>
        </AppBar>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loading: state.auth.loading,
    providerId: state.auth.providerId,
    balance: state.sportsBook.balance,
    currency: state.sportsBook.currency,
    theme: state.common.theme,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setProviderId: (pid: string) => dispatch(setProviderId(pid)),
    fetchBalance: () => dispatch(fetchBalance()),
    setTheme: (theme: string) => dispatch(setTheme(theme)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderPage);
